import React from 'react';
import { ErrorOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import './stylesDataConfirmation.css';

export default function ErrorMessage({ message }) {

		const { t } = useTranslation();

    return(
		<div className='data-confirmation__loading'>
			<ErrorOutline style={{ color: 'red', fontSize: '5rem' }}/>
			<h1>{ t('errors.try_again') }</h1>
			<p>{message}</p>
		</div>   
    );
}